// 分享相关
import { shareByWX } from '../BsWxsdk';
import Env from '../BsGetEnv';
import BsUtil from '../BsUtil';

export {shareByWX};

/**
 * 嘀嗒出行App页面webview下方分享按钮
 * @param title 标题
 * @param desc 内容
 * @param link 链接
 * @param imgUrl 分享图标
 */
export function shareByAppMinPg(
  {
    title, 
    desc, 
    link, 
    imgUrl, 
    id = 'statusBarShare', 
    showChannel, 
    minipgThumbnail,
    minipgTitle,
    minipgDes,
    minipgLink,
    minipgUserName,
    minipgWithShareTicket,
    minipgType
  } = {}
  ) {
  if(!window.DIDASDK){
    console.log('DIDASDK没有引入！');
    return;
  } 
  if (!Env.inApplication) {
    return;
  }
  let shareInfo = {
    thumbnail: imgUrl,
    title,
    des: desc,
    link,
    id,
    showChannel,
    minipgThumbnail,
    minipgTitle,
    minipgDes,
    minipgLink,
    minipgUserName,
    minipgWithShareTicket,
    minipgType
  };
  window.DIDASDK.invoke('statusBarShare',shareInfo);
}

/**
 * 嘀嗒出行App页面webview下方分享按钮
 * @param title 标题
 * @param desc 内容
 * @param link 链接
 * @param imgUrl 分享图标
 */
export function shareByAppBtn({title, desc, link, imgUrl, id = 'statusBarShare', showChannel} = {}) {
  if(!window.DIDASDK){
    console.log('DIDASDK没有引入！');
    return;
  } 

  if (!Env.inApplication) {
    return;
  }

  let shareInfo = {
    thumbnail: imgUrl,
    title,
    des: desc,
    link,
    id,
    showChannel
  };


  window.DIDASDK.invoke('statusBarShare',shareInfo);

  // 使用jsBridge分享
  // didasdk.ready(() => {
  //   didasdk.shareByAppBtn(shareInfo);
  // });
}

/**
 * 客户端分享
 * 包括出行端App右下角分享和微信二次分享
 * @param shareInfo
 * shareInfo可能的key值
 *   title 分享标题
 *   desc 分享内容
 *   link 分享链接
 *   imgUrl 分享图标
 *   success 成功回调
 *   fail 失败回调
 *   cancel 取消回调
 */
export function shareByClient(shareInfo = {}) {
  shareByAppBtn(shareInfo);
  shareByWX(shareInfo);
}

/**
 * h5页面内按钮
 * 适用于点击h5界面中button弹出分享控件
 * @param title 标题
 * @param desc 内容
 * @param link 链接
 * @param imgUrl 分享图标
 */
export function shareByH5Btn({title, desc, link, imgUrl, id = 'clickControlToShare'} = {}) {
  if(!window.DIDASDK){
    console.log('DIDASDK没有引入！');
    return;
  } 
  let shareInfo = {
    thumbnail: imgUrl,
    title,
    des: desc,
    link,
    id
  };
  window.DIDASDK.invoke('clickControlToShare',shareInfo);
  // jsBridge 分享
  // didasdk.ready(() => {
  //   didasdk.shareByH5Btn(shareInfo);
  // });
}
/**
 * 分享至指定App
 * @param title 标题
 * @param desc 内容
 * @param link 链接
 * @param imgUrl 分享图标
 */
export function shareByDingtalk({title, desc, link, imgUrl, ddType=0} = {}){
  window.dd.ready(function() {
      // 查看是否可以调用内置钉钉浏览器
    if (window.dd) {
      window.dd.biz.navigation.setTitle({
        title: title, // 控制标题文本，空字符串表示显示默认文本
        onSuccess: function(result) {},
        onFail: function() {}
      })
      // 钉钉右上角更多事件控制
      window.dd.biz.navigation.setRight({
        show: true, // 控制按钮显示， true 显示， false 隐藏， 默认true
        control: true, // 是否控制点击事件，true 控制，false 不控制， 默认false
        text: '···', // 控制显示文本，空字符串表示显示默认文本
        onSuccess: function(result) {
          // 钉钉内置分享
          window.dd.biz.util.share({
            type: ddType, // 分享类型，0:全部组件 默认； 1:只能分享到钉钉；2:不能分享，只有刷新按钮
            url: link,
            title: title,
            content: desc,
            image: imgUrl,
            onSuccess: function() {},
            onFail: function() {}
          })
        },
        onFail: function() {}
      })
    }
  })
}
/**
 * 分享至指定App
 * @param title 标题
 * @param desc 内容
 * @param link 链接
 * @param imgUrl 分享图标
 * @param channel wxmsg、wxtimeline、dingtalk、message
 */
export function shareByH5Channel({title, desc, link, imgUrl, channel, id = 'shareOnTheWebviewPage'} = {}) {
  if (!channel) {
    console.error('使用shareByH5Channel方法必须传入channel属性，可选值为：wxmsg、wxtimeline、dingtalk、message');
  }

  if(!window.DIDASDK){
    console.log('DIDASDK没有引入！');
    return;
  } 

  let shareInfo = {
    thumbnail: imgUrl,
    title,
    des: desc,
    link,
    id,
    channel
  };
  window.DIDASDK.invoke('shareOnTheWebviewPage',shareInfo);
  // jsBridge 分享
  // didasdk.ready(() => {
  //   didasdk.shareByH5Channel(shareInfo);
  // });
}

/**
 * 默认分享数据（小程序）
 */
const DEFAULT_MINIPG_SHARE_DATA = {
  title: '我正在使用嘀嗒顺风车',
  link: '/pages/index',
  imgUrl: 'https://static.didapinche.com/pics/g/jcj8lthj9u/shareico.png'
};

const DEFAULT_IMG_OPTS = {
  width: 624,
  height: 860,
  x: 0,
  y: 0
};

/* global wx */
/**
 * @description 分享
 * @param {object} [options={}] - 注册分享事件参数
 * @param {object} options.data - 通用配置
 * @param {object} options.shareByWx - 微信H5渠道配置（右上角三个点分享）
 * @param {object} options.shareByApp - App webview渠道配置（右下角分享按钮）
 * @param {object} options.shareByMinipg - 小程序webview渠道配置（右上角三个点分享）
 * @param {object} options.shareByAppMinPg
 */
export default class Share {
  constructor({ data = {}, shareByWx = {}, shareByApp = {}, shareByMinipg = {}, shareByDingtalk = {}, shareByAppMinPg = {} } = {}) {
    this.options = {};
    this.options.commonData = { ...data };
    this.options.shareByWx = { enable: false, ...shareByWx };
    this.options.shareByApp = { enable: false, ...shareByApp };
    this.options.shareByMinipg = { enable: false, ...shareByMinipg };
    this.options.shareByDingtalk = { enable: false, ...shareByDingtalk };
    this.options.shareByAppMinPg = { enable: false, ...shareByAppMinPg };
    this._bindShare();
  }

  _bindShare() {
    if (Env.inWechat) {
      wx.miniProgram.getEnv((res) => {
        if (res.miniprogram && this.options.shareByMinipg.enable) {
          const _shareFunction = () => {
            const _tmp = { ...this.options.commonData, ...this.options.shareByMinipg };
            wx.miniProgram.postMessage({
              data: {
                imageUrl: _tmp.imgUrl,
                title: _tmp.title,
                path: _tmp.link
              }
            });
          };
          if (!window.WeixinJSBridge || !window.WeixinJSBridge.invoke) {
            document.addEventListener('WeixinJSBridgeReady', _shareFunction, false);
          } else {
            _shareFunction();
          }
        } else if (this.options.shareByWx.enable) {
          shareByWX({ ...this.options.commonData, ...this.options.shareByWX });
        }
      });
    }
    if (Env.inApplication && this.options.shareByAppMinPg.enable) {
      shareByAppMinPg({ ...this.options.commonData, ...this.options.shareByAppMinPg });
    }
    if (Env.inApplication && this.options.shareByApp.enable) {
      shareByAppBtn({ ...this.options.commonData, ...this.options.shareByApp });
    }
    var ua = navigator.userAgent.toLowerCase()

    if(ua.indexOf('dingtalk') !== -1 && window.dd && this.options.shareByDingtalk.enable){
      shareByDingtalk({...this.options.commonData, ...this.options.shareByDingtalk})
    }
  }

  /**
   * App webView 页面内按钮直接分享 (app环境可用)
   * @param {string} channel - 渠道 wxmsg: 微信好友（H5） | wximage: 海报图（朋友圈） | wxtimeline: 微信朋友圈 | dingtalk: 钉钉 | message: 短信 | wxminipg: 微信小程序
   * @param {object} [shareData={}] - 分享数据
   * @param {string} shareData.id - 标识从哪里点击的分享
   * @param {string} shareData.title - 标题
   * @param {string} shareData.desc - 描述
   * @param {string} shareData.link - 要分享的地址
   * @param {string} shareData.imgUrl - 缩略图地址
   * @param {object} shareData.imgOpts - 分享图片配置（仅 channel 为 wximage 时可用）
   * @param {number} shareData.imgOpts.width - 图片宽度（canvasWidth 和 imgdata.width）
   * @param {number} shareData.imgOpts.height - 图片宽度（canvasHeight 和 imgdata.height）
   * @param {number} shareData.imgOpts.x - 图片宽度（imgdata.x）
   * @param {number} shareData.imgOpts.y - 图片宽度（imgdata.y）
   */
  static shareByApp(channel, { title, desc, link, imgUrl, imgOpts = {}, id = 'shareOnTheWebviewPage'} = {}) {
    if (!['wxmsg', 'wximage', 'wxtimeline', 'dingtalk', 'message', 'wxminipg'].indexOf(channel) > -1) {
      console.error('使用shareByApp方法必须传入channel属性，可选值为：wxmsg、wximage、wxtimeline、dingtalk、message、wxminipg');
      return;
    }

    if (Env.inApplication) {
      if (BsUtil.compareVersion(Env.curAppVersion, '8.9.0') === -1 && ['wxtimeline', 'wxminipg']) {
        console.warn(`当前版本: ${Env.curAppVersion}, 请升级至最新版本参与活动`);
      } else {
        if(!window.DIDASDK){
          console.log('DIDASDK没有引入！');
          return;
        } 
      
        // didasdk.ready(() => {
          if (channel === 'wxminipg') { // 分享微信小程序
            const sharedata = {
              id,
              minipgThumbnail: imgUrl, // 缩略图地址
              minipgTitle: title, // 标题
              minipgDes: desc, // 描述
              minipgLink: link, // 小程序页面路径
              minipgWithShareTicket: true, // 是否使用带shareTicket的分享
              minipgType: Env.isEnvOnline ? 0 : 2, // 小程序的类型 0-正式版 1-测试(开发)版 2-体验版
              minipgUserName: 'gh_49e3fa80623f' // 小程序原始id（顺风车）
            };
            // didasdk.callHandler('shareWxMinipg', sharedata);
            window.DIDASDK.invoke('shareWxMinipg',sharedata);
          } else if (channel === 'wximage') { // 分享微信朋友圈图片
            const tmpOpts = { ...DEFAULT_IMG_OPTS, ...imgOpts };
            const sharedata = {
              title, // 标题
              des: desc, // 描述
              canvasWidth: tmpOpts.width,
              canvasHeight: tmpOpts.height,
              imgdata: [{
                url: imgUrl, // 图片链接
                width: tmpOpts.width, // 图片宽度
                height: tmpOpts.height, // 图片高度
                x: tmpOpts.x, // 图片左上角横坐标
                y: tmpOpts.y // 图片左上角纵坐标
              }]
            };
            // didasdk.callHandler('shareWxImages', sharedata);
            window.DIDASDK.invoke('shareWxImages',sharedata);
          } else {
            const sharedata = { // 其他渠道
              thumbnail: imgUrl,
              title,
              des: desc,
              link,
              id,
              channel
            };
            // didasdk.callHandler('shareOnTheWebviewPage', sharedata);
            window.DIDASDK.invoke('shareOnTheWebviewPage',sharedata);
          }
        // });
      }
    }
  }

  /**
   * 调起App分享组件（App环境可用）
   * @param {object} [shareData={}] - 分享数据
   * @param {string} shareData.id - 标识从哪里点击的分享
   * @param {string} shareData.title - 标题
   * @param {string} shareData.desc - 描述
   * @param {string} shareData.link - 要分享的地址
   * @param {string} shareData.imgUrl - 缩略图地址
   */
  static showAppShareComponent({ title, desc, link, imgUrl, id = 'clickControlToShare'} = {}) {
    if (Env.inApplication) {
      if(!window.DIDASDK){
        console.log('DIDASDK没有引入！');
        return;
      } 
      // didasdk.ready(() => {
        const sharedata = {
          thumbnail: imgUrl,
          title,
          des: desc,
          link,
          id
        };
        // return this.callHandler('clickControlToShare', sharedata);
        return window.DIDASDK.invoke('clickControlToShare',sharedata);
      // });
    }
  }

  /**
   * 调起小程序分享组件（minipg环境可用）
   * @param {object} [componentData={}] - 组件配置数据
   * @param {string} componentData.title - 组件展示标题
   * @param {string} componentData.imgUrl - 组件展示背景图
   * @param {number|string} [componentData.channel=3] - 组件展示按钮控制 1: 微信好友 2: 保存海报 3: all
   * @param {string} componentData.postImg- 组件下载海报图配置
   * @param {object} [componentData.shareData=DEFAULT_SHARE_DATA]  - 组件分享数据
   * @param {string} componentData.shareData.title - 分享小程序卡片标题
   * @param {string} componentData.shareData.link - 分享小程序卡片地址
   * @param {string} componentData.shareData.imgUrl - 分享小程序卡片缩略图
   */
  static showWxMinipgShareComponent({ title, imgUrl, channel = 3, postImg, shareData = DEFAULT_MINIPG_SHARE_DATA } = {}) {
    if (Env.inWechat) {
      wx.miniProgram.getEnv(res => {
        if (res.miniprogram) {
          wx.miniProgram.navigateTo({
            url: `/pages/sharecomponent?title=${title}&imgUrl=${imgUrl}&channel=${channel}&postImg=${postImg}&shareTitle=${shareData.title}&sharePath=${shareData.link}&shareImgUrl=${shareData.imgUrl}`
          });
        }
      });
    }
  }
}

